import * as Yup from 'yup'

import LookupType from './LookupType'

export const EstimateSchema = Yup.object().shape({
    company: LookupType
        .label('Company')
        .default(null)
        .nullable()
        .required(),

    company_supervisor: LookupType
        .label('Supervisor')
        .default(null)
        .nullable(),

    name: Yup
        .string()
        .label('Job Name')
        .min(1)
        .required(),

    phone: Yup
        .string()
        .label('Phone')
        .nullable()
        .length(14, 'Please enter a 10-digit phone number.'),

    key_map: Yup.string().nullable(),
    entered_date: Yup.string().nullable(),
    lat: Yup.number().nullable(),
    lon: Yup.number().nullable(),
    address_line_1: Yup.string().nullable(),
    address_line_2: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    county: Yup.string().nullable(),
    mmg_mileage: Yup.string().nullable(),
    manchaca_mileage: Yup.string().nullable(),
    gate_code: Yup.string().nullable(),
    notes: Yup.string().nullable(),
    is_central_texas: Yup.boolean().required(),
    is_display: Yup.boolean().required(),
    is_commercial: Yup.boolean().required(),
    is_estimate: Yup.boolean().required(),
    is_preliminary: Yup.boolean().required(),
    is_approved_by_user_id: Yup.string().nullable(),
    was_estimated: Yup.boolean(),
    is_conversion: Yup.boolean()
})

export const PresaveCheckEstimateSchema = Yup.object().shape({
    company: LookupType
        .label('Company')
        .default(null)
        .nullable()
        .required(),

    address_line_1: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable()
})